import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Zoom from '@mui/material/Zoom';
import InputAdornment from '@mui/material/InputAdornment';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
const LabelContainer = () => {
  return (
    <div className="labelContainer layered-soil-layer">
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
        }}
        style={{ minWidth: 75, maxWidth: 150 }}
        size="small"
        variant="outlined"
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title="Soil layer ID" arrow placement="bottom" TransitionComponent={Zoom}>
                <InfoTwoToneIcon fontSize={'string'} />
              </Tooltip>
            </InputAdornment>
          ),
          style: { fontWeight: 600 },
        }}
        disabled
        value="Layer Id"
      />

      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
        }}
        style={{ minWidth: 75, maxWidth: 150 }}
        size="small"
        variant="outlined"
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip
                title="Starting point of soil layer measured from ground surface (m).  "
                arrow
                placement="bottom"
                TransitionComponent={Zoom}
              >
                <InfoTwoToneIcon fontSize={'string'} />
              </Tooltip>
            </InputAdornment>
          ),
          style: { fontWeight: 600 },
        }}
        disabled
        value={'z₁'}
      />
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
        }}
        style={{ minWidth: 75, maxWidth: 150 }}
        size="small"
        variant="outlined"
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip
                title="Ending point of soil layer measured from ground surface (m). "
                arrow
                placement="bottom"
                TransitionComponent={Zoom}
              >
                <InfoTwoToneIcon fontSize={'string'} />
              </Tooltip>
            </InputAdornment>
          ),
          style: { fontWeight: 600 },
        }}
        disabled
        value="z₂"
      />
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
        }}
        style={{ minWidth: 75, maxWidth: 150 }}
        size="small"
        variant="outlined"
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip
                title="Soil layer thickness. Equals to z₂ – z₁ of corresponding soil layer (m) "
                arrow
                placement="bottom"
                TransitionComponent={Zoom}
              >
                <InfoTwoToneIcon fontSize={'string'} />
              </Tooltip>
            </InputAdornment>
          ),
          style: { fontWeight: 600 },
        }}
        disabled
        value="Hᵢ"
      />
      <TextField
        sx={{
          '& legend': { display: 'none' },
          '& fieldset': { top: 0 },
        }}
        style={{ minWidth: 75, maxWidth: 150 }}
        size="small"
        variant="outlined"
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title="Shear wave velocity of the soil layer (m/s) " arrow placement="bottom" TransitionComponent={Zoom}>
                <InfoTwoToneIcon fontSize={'string'} />
              </Tooltip>
            </InputAdornment>
          ),
          style: { fontWeight: 600 },
        }}
        disabled
        value="Vs"
      />
    </div>
  );
};
export default LabelContainer;
